import { useMemo } from 'react';
import Text from 'components/design-system/Text/Text';

export const useColumnTablesListadoGrupos = () => {
  const columnTables = useMemo(
    () => [
      {
        header: 'Nombre del grupo',
        enableGlobalFilter: true,
        accessorKey: 'nombreGrupo',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>,
        enableColumnActions: true,
        enableColumnFilter: true,
        muiTableHeadCellProps: {
          align: 'left'
        },
        muiTableBodyCellProps: {
          align: 'left'
        }
      },
      {
        header: 'N° de negocios',
        enableGlobalFilter: false,
        accessorKey: 'empresas.length',
        enableColumnActions: false,
        enableColumnFilter: false,

        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>
      }
    ],
    []
  );

  return columnTables;
};
